<template>
  <component
    :is="tag as string"
    class="t-menu-item flex"
    :class="[
      selected
        ? 'border-primary-800 text-gray-900'
        : 'border-transparent text-gray-600 hover:border-primary-800 hover:text-gray-900',
      'block pl-3 pr-4 py-3 border-l-4 text-base font-bold transition ease-in-out duration-300 relative',
      classes,
    ]"
  >
    <UIcon
      :name="icon"
      class="w-6 h-6 mr-3 text-primary-800"
      aria-hidden="true"
    />
    <slot />
    <span
      v-if="unread > 0"
      class="rounded-full w-5 h-5 bg-red-600 text-white absolute right-4 flex items-center justify-center font-bold leading-none text-xs"
      >{{ unread }}</span
    >
  </component>
</template>

<script setup lang="ts">
import type { PropType } from 'vue'

defineProps({
  unread: {
    type: Number,
    default: 0,
  },
  icon: {
    type: String,
    default: '',
  },
  selected: {
    type: Boolean,
    default: false,
  },
  tag: {
    type: String as PropType<string>,
    default: 'a',
  },
  classes: {
    type: String,
  },
  html: {
    type: [String],
  },
})
</script>
